import React from "react";
import ReactDOM from "react-dom/client";
import { getCalApi } from "@calcom/embed-react";
import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { CookieConsent } from "@/components/CookieConsent";
import { newsRouter } from "@/app/news-routes";
import "@/styles/index.css";
import { initObservability } from "@/lib/observability";
import { CAL_NAMESPACE, CAL_BRAND_COLOR } from "@/lib/cal-config";
import { trackCompletedBookings } from "@/lib/book-a-call";

/**
 * Dedicated client entry for the /news surface. Identical bootstrap to main.tsx
 * (observability + Cal embed for the navbar's "Book a demo" + query client +
 * cookie consent) but it mounts the NEWS-ONLY router (app/news-routes), so the
 * news bundle never includes the rest of the landing SPA. See app/news-routes
 * for why this matters.
 */

initObservability();

void (async () => {
  const cal = await getCalApi({ namespace: CAL_NAMESPACE });
  cal("ui", {
    theme: "light",
    cssVarsPerTheme: { light: { "cal-brand": CAL_BRAND_COLOR } },
    hideEventTypeDetails: false,
    layout: "month_view",
  });
})();
void trackCompletedBookings();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={newsRouter} />
      <CookieConsent />
    </QueryClientProvider>
  </React.StrictMode>
);
